import { ApiClient } from '@/services/api-client.ts'

export interface NotificationDTO {
  id: number | string
  type: string
  title: string
  message: string
  data?: any
  read?: boolean
  status?: string
  createdAt?: string
  updatedAt?: string
}

export const NotificationsApi = {
  async list(): Promise<NotificationDTO[]> {
    const res = await ApiClient.get<any>('/notifications')
    // Backend devuelve { success, count, notifications }
    const list = (res as any)?.notifications || []
    return list
  },

  async unreadCount(): Promise<number> {
    const res = await ApiClient.get<any>('/notifications/unread-count')
    return (res as any)?.unreadCount ?? 0
  },

  async markAsRead(id: string | number): Promise<void> {
    await ApiClient.patch(`/notifications/${id}/read`)
  }
}

export default NotificationsApi
